<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>机器人偷</span>
          <el-button type="primary" size="mini" style="margin-left: 16px;" @click="edit(0)">新增</el-button>
        </div>

        <template>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="id"
              label="ID"
              align="center"
            />
            <el-table-column
              label="偷取类型"
              align="center"
            >
              <template scope="scope">
                <span v-if="scope.row.steal_type===1">按比例({{ scope.row.ratios }}%)</span>
                <span v-else>固定值({{ scope.row.y_ratios.start }}%-{{ scope.row.y_ratios.end }}%)</span>
              </template>
            </el-table-column>
            <el-table-column
              label="偷取方式"
              align="center"
              width="200"
            >
              <template scope="scope">
                <span v-if="scope.row.steal_method===1">手动偷</span>
                <span v-else>自动偷 <br>{{ scope.row.date.start }} <br>{{ scope.row.date.end }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="偷取目标"
              align="center"
            >
              <template scope="scope">
                <span v-if="scope.row.steal_method===1">用户UID:{{ scope.row.uid }}</span>
                <span v-else>排名前{{ scope.row.rank }}名</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="cool_off"
              label="冷却时间(秒)"
              align="center"
            />
            <el-table-column
              prop="cool_off"
              label="随机延迟(秒)"
              align="center"
            >
              <template scope="scope">
                {{ scope.row.rand_num.start }}-{{ scope.row.rand_num.end }}
              </template>
            </el-table-column>
            <el-table-column
              label="偷取次数"
              align="center"
            >
              <template scope="scope">
                <span v-if="scope.row.steal_method===1">次数:{{ scope.row.count.start }}</span>
                <span v-else>范围:{{ scope.row.count.start }}-{{ scope.row.count.start }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              align="center"
              :formatter="statusFormatter"
            />
            <el-table-column
              fixed="right"
              label="操作"
              width="100"
            >
              <template slot-scope="scope">
                <el-button v-if="scope.row.status !== 3" type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>
                <el-button v-if="scope.row.status !== 1" type="text" size="small" @click="del(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total>0"
            background
            :page.sync="queryParams.pageIndex"
            :limit.sync="queryParams.pageSize"
            :total="total"
            @pagination="getTables"
          />
        </template>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { delRobotSteal, getRobotStealList } from '@/api/config/robot-steal'

export default {
  name: 'RobotSteal',
  data() {
    return {
      total: 0,
      tableData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleClose(d) {
      this.drawer = false
    },
    edit(id) {
      this.$router.push({ name: 'RobotStealEdit', query: { id: id }})
    },
    getTables() {
      getRobotStealList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(id) {
      delRobotSteal({ id: id }).then(res => {
        this.msgSuccess('删除成功')
        this.getTables()
      })
    },
    statusFormatter(row, col) {
      const typeText = ['未运行', '运行中', '手动停止', '已完成']
      return typeText[row.status]
    }
  }
}
</script>

<style scoped>
</style>
